import React from 'react';

const Facebook: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 36" {...props}>
    <path
      fill="currentColor"
      d="M5.52 36V19.898H0V13.5h5.52V8.459C5.52 2.98 8.946 0 13.948 0c2.396 0 4.455.176 5.052.253v5.724h-3.469c-2.72 0-3.246 1.265-3.246 3.114V13.5h6.14l-.843 6.398h-5.297V36"
    ></path>
  </svg>
);

export default Facebook;
